// Normalizes a string by replacing accented characters, removing dots and hyphens, and converting to lowercase.
export default function normalize(text) {
  const charMap = {
    á: "a",
    é: "e",
    í: "i",
    ó: "o",
    ö: "o",
    ú: "u",
    ü: "u",
    Á: "A",
    É: "E",
    Í: "I",
    Ó: "O",
    Ö: "O",
    Ú: "U",
    Ü: "U",
  };

  if (typeof text !== "string") return "";

  return text
    .toString()
    .replace(/[áéíóöúüÁÉÍÓÖÚÜ]/g, (char) => charMap[char]) // Replace accented characters.
    .trim()
    .replace(/[.:-]/g, "") // Remove dots and hyphens.
    .toLowerCase(); // Convert to lowercase.
}
